import { PayloadAction } from '@reduxjs/toolkit';
import { SyncSnapQuoteLineOutput } from '@snap-types/actions/sync-snap-quote-line';
import { WritableDraft } from 'immer';

import { QuoteLineParams } from '../../types/shared';
import { QuoteBuilderStateType } from '../../types/state';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { buildIssueId } from '../utilities/issue-id';
import { deleteIssue, upsertIssue } from '../utilities/issue-managers';
import { transformPartialQuoteLine } from '../utilities/transform-quote-line';

export function quoteLineSyncTriggered(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<QuoteLineParams>,
) {
  const { quoteLineUuid } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  quoteLine.status = 'syncing';
}

export function quoteLineSyncSucceeded(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<
    QuoteLineParams & { updatedQuoteLine: SyncSnapQuoteLineOutput }
  >,
) {
  const { quoteLineUuid, updatedQuoteLine } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  const transformedQuoteLine = transformPartialQuoteLine(
    updatedQuoteLine,
    state.calculationConfig,
  );

  deleteIssue(
    state,
    buildIssueId({
      area: 'quoteLine',
      quoteLineUuid,
      type: 'rejected',
    }),
  );

  Object.assign(quoteLine, transformedQuoteLine);

  quoteLine.status = 'ready';
}

export function quoteLineSyncFailed(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<QuoteLineParams>,
) {
  const { quoteLineUuid } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  quoteLine.status = 'ready';

  upsertIssue(
    state,
    buildIssueId({
      area: 'quoteLine',
      quoteLineUuid,
      type: 'rejected',
    }),
    {
      title: 'Failed to Sync Quote Line',
      description: 'Quote line could not be synced with Visual',
      area: 'quoteLine',
      quoteLineUuid,
      severity: 'error',
      type: 'rejected',
      action: {
        type: 'unrecoverable',
      },
    },
  );
}
